const actions = {
  CHECK_AUTHORIZATION: 'CHECK_AUTHORIZATION',
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGIN_REQUEST_SIIGO: 'LOGIN_REQUEST_SIIGO',
  LOGOUT: 'LOGOUT',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_SUCCESS_SIIGO: 'LOGIN_SUCCESS_SIIGO',
  LOGIN_ERROR: 'LOGIN_ERROR',
  LOGIN_SIGNUP: 'LOGIN_SIGNUP',
  PASS_RECOVERY: 'PASS_RECOVERY',
  SET_RECOVERY: 'SET_RECOVERY',
  UPDATE_LOGIN_INFO: 'UPDATE_LOGIN_INFO',
  TOKEN_LOGIN_SIIGO: 'TOKEN_LOGIN_SIIGO',
  checkAuthorization: () => ({ type: actions.CHECK_AUTHORIZATION }),
  login: (data) => ({
    type: actions.LOGIN_REQUEST,
    payload: data,
  }),
  loginSiigo: (data) => ({
    type: actions.LOGIN_REQUEST_SIIGO,
    payload: data,
  }),
  logout: () => ({
    type: actions.LOGOUT,
  }),
  signup: (data) => ({
    type: actions.LOGIN_SIGNUP,
    payload: data,
  }),
  passRecovery: (data) => ({
    type: actions.PASS_RECOVERY,
    payload: data,
  }),
  setRecovery: (data) => ({
    type: actions.SET_RECOVERY,
    payload: data,
  }),
};
export default actions;
